export default __webpack_public_path__ + "static/media/arrow-curved-line.9754518c.svg";